/**
 * Access-denied screen — the fail-closed terminal state of the admin gate.
 * Rendered for BOTH a definitive non-admin answer (`{ admin: false }`) and any
 * error/uncertainty (401, network, parse). The copy stays the same either way:
 * we never leak whether the failure was "you're not an admin" vs "the check
 * errored" — both are simply "no admin access" to the viewer.
 */
import { Link } from 'react-router';

export function AdminDenied({ reason }: { reason: 'not-admin' | 'error' }) {
  return (
    <div className="flex h-full w-full items-center justify-center p-6">
      <div
        className="max-w-md rounded-md border border-border-subtle bg-surface-foreground p-6 text-center"
        data-testid="admin-denied"
        data-reason={reason}
      >
        <h1 className="font-sans font-semibold text-content-primary">
          Access denied
        </h1>
        <p className="mt-2 font-inter text-content-secondary text-sm">
          You don&apos;t have admin access to this area. If you believe this is
          a mistake, contact an administrator.
        </p>
        <Link
          className="mt-4 inline-block font-inter text-content-action text-sm hover:underline"
          to="/"
        >
          Back to chat
        </Link>
      </div>
    </div>
  );
}
